import { graphql } from "react-relay";

export const QUERY = graphql`
	query videoSourcesScreen_Query {
		...videoSourcesTable_QueryFragment
	}
`;
